module.exports = __webpack_public_path__ + "img/4.053997a0.jpg";